import { useState } from 'react';
import LscMapData from './LscMapData';

const useClubRegistrationRequirmentData = () => {
  const [ lscMapState, setLscMapState ] = useState(LscMapData.INITIAL_STATE);

  const getLscMaps = () => {
    return LscMapData.getLscMapData(lscMapState, setLscMapState);
  }

  return {
    lscMapState,
    getLscMaps
  }
}

export default useClubRegistrationRequirmentData;